export type EntityScope = "me" | "everyone";

export type ScopeOption = { id: EntityScope; label: string };

export const SCOPE_OPTIONS: [ScopeOption, ...ScopeOption[]] = [
	{ id: "me", label: "Me" },
	{ id: "everyone", label: "Everyone" },
];

export const isEntityScope = (value: unknown): value is EntityScope =>
	value === "me" || value === "everyone";

export const scopeMatches = (
	scope: EntityScope,
	ownerUserId: string | null | undefined,
	currentUserId: string,
): boolean => scope === "everyone" || ownerUserId === currentUserId;
